export default {
  'feedback.name': 'Góp ý',
  'feedback.heading': 'Danh sách góp ý',
  'feedback.code': 'Mã góp ý',
  'feedback.title': 'Tiêu đề',
  'feedback.content': 'Nội dung vấn đề',
  'feedback.creator': 'Người tạo',
  'feedback.clubCreator': 'Thuộc câu lạc bộ',
  'feedback.createdAt': 'Ngày tạo',
  'feedback.status': 'Trạng thái',
  'feedback.status.param':
    '{status,select, 1 {Đã phản hồi} 2 {Chưa phản hồi} other {Không xác định}}',
  'feedback.action': 'Hành động',
  'feedback.status.replied': 'Đã phản hồi',
  'feedback.status.un-replied': 'Chưa phản hồi',
  'feedback.belongClubIds': 'Thuộc câu lạc bộ',
  'feedback.detailPage.title': 'Chi tiết Góp ý',
  'feedback.detailPage.creator': 'Người góp ý',
  'feedback.detailPage.phoneNumber': 'Số điện thoại',
  'feedback.detailPage.dateCreator': 'Ngày góp ý',
  'feedback.detailPage.reply': 'Trả lời phản hồi',
  'feedback.detailPage.contentText': 'Nội dung vấn đề',
  'feedback.detailPage.contentFile': 'Nội dung đính kèm',
  'feedback.detailPage.download': 'Tải xuống',
  'feedback.reply': 'Gửi phản hồi',
  'feedback.attachFile': 'Tệp đính kèm',
  'feedback.send': 'Gửi',
  'feedback.detailPage.contentReply': 'Nội dung phản hồi',
  'feedback.detailPage.contentReplyTime': 'Thời gian phản hồi',
  'feedback.by': ' bởi',
  'feedback.info': 'Chi tiết Góp ý',
  'feedback.edit': 'Cập nhật Góp ý',
};
